import { z } from 'zod';

const featureSchema = z.object({
  label: z.string(),
  description: z.string().optional(),
});

export type Feature = z.infer<typeof featureSchema>;

export const planIdSchema = z.enum(['individual', 'team', 'team-pro', 'enterprise']);

export const planMetadataSchema = z.object({
  id: planIdSchema,
  title: z.string(),
  description: z.string().optional(),
  numberOfUsers: z.string().optional(),
  featuresBlurb: z.string().optional(),
  features: z.array(featureSchema),
  footnote: z.string().optional(),
  tags: z.array(z.string()).optional(),
});

export type PlanMetadata = z.infer<typeof planMetadataSchema>;
export type PlanId = z.infer<typeof planIdSchema>;
